import { Button } from "react-bootstrap";
import styled from "styled-components";

interface ErrorStateProps {
    message: string;
    onRetry: () => void;
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
    return (
        <ErrorStateWrapper>
            <p className="error-message">{message}</p>
            <Button variant="outline-secondary" onClick={onRetry}>
                Tentar Novamente
            </Button>
        </ErrorStateWrapper>
    );
}

const ErrorStateWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 3rem 0;
    gap: 1rem;

    .error-message {
        font-family: Lato;
        font-size: 1rem;
        color: #D30808;
        margin: 0;
    }
`;
